// extracted by mini-css-extract-plugin
module.exports =  {"input":"Jhc2Sto","success":"zXXRHik","error":"PLfv63P","hide-number-spin-button":"viIzSeV","hideNumberSpinButton":"viIzSeV"};